import React from 'react';

export default class NEABALogo extends React.Component {
  render() {

    const styles = {      
      st1: { fill: '#6D2B8D' },
      st2: { fill: '#FFFFFF' },
    };
    return (<div className="logo">

  <svg width="200px" height="60px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        viewBox="0 0 263.6 105.2" style={{ enableBackground: 'new 0 0 263.6 105.2' }} >
  <g>
    <path style={styles.st1} d="M7.5,84.2h5.2l5.9,7.3v-7.3h5.5v16.6h-4.9L13,93.2v7.7H7.5V84.2z"/>
    <path style={styles.st1} d="M26.2,84.2h14.2v4.6h-8.7v1.7h8.1v4h-8.1v1.8h8.8v4.6H26.2V84.2z"/>
    <path style={styles.st1} d="M41.3,84.2h5.8l2.4,8l2.7-8H57l2.7,8l2.4-8h5.7L62.3,101h-4.8l-2.9-8.3l-2.9,8.3h-4.8L41.3,84.2z"/>
    <path style={styles.st1} d="M75.2,84.2h14.2v4.6h-8.7v1.7h8.1v4h-8.1v1.8h8.8v4.6H75.2V84.2z"/>
    <path style={styles.st1} d="M91.2,84.2h5.2l5.9,7.3v-7.3h5.5v16.6h-4.9l-6.2-7.7v7.7h-5.5V84.2z"/>
    <path style={styles.st1} d="M118.9,101.2c-1.3,0-2.5-0.2-3.6-0.6c-1.1-0.4-2.1-1-3-1.8c-0.8-0.8-1.5-1.7-2-2.7s-0.7-2.2-0.7-3.5v0
      c0-1.2,0.2-2.4,0.7-3.4c0.5-1.1,1.1-2,1.9-2.8c0.8-0.8,1.8-1.4,2.9-1.8s2.3-0.7,3.6-0.7c1.4,0,2.7,0.2,3.9,0.7
      c1.1,0.4,2.2,1.1,3.1,1.9l-3.1,3.8c-0.6-0.5-1.1-0.8-1.7-1.1c-0.6-0.3-1.3-0.4-1.9-0.4c-0.5,0-1,0.1-1.5,0.3
      c-0.5,0.2-0.9,0.5-1.2,0.8c-0.3,0.3-0.6,0.8-0.8,1.2c-0.2,0.5-0.3,1-0.3,1.6v0c0,0.6,0.1,1.1,0.3,1.6c0.2,0.5,0.5,0.9,0.8,1.3
      c0.3,0.3,0.8,0.6,1.2,0.8c0.5,0.2,1,0.3,1.6,0.3c0.5,0,0.9,0,1.1-0.1c0.3-0.1,0.5-0.2,0.8-0.3v-1.7h-2.9V91h8.1v7.7
      c-0.9,0.7-2,1.3-3.2,1.8C121.8,101,120.5,101.2,118.9,101.2z"/>
    <path style={styles.st1} d="M128.1,84.2h5.6v11.9h7.8v4.8h-13.4V84.2z"/>
    <path style={styles.st1} d="M148.8,84.1h5.5l7,16.7h-6l-0.9-2.2h-5.8l-0.9,2.2h-5.9L148.8,84.1z M153,94.7l-1.5-4l-1.5,4H153z"/>
    <path style={styles.st1} d="M162.2,84.2h5.2l5.9,7.3v-7.3h5.5v16.6h-4.9l-6.2-7.7v7.7h-5.5V84.2z"/>
    <path style={styles.st1} d="M181,84.2h6.4c1.6,0,3.1,0.2,4.3,0.6s2.3,0.9,3.1,1.7s1.4,1.6,1.9,2.6c0.4,1,0.6,2.1,0.6,3.4v0
      c0,1.2-0.2,2.4-0.6,3.4c-0.4,1-1.1,1.9-1.9,2.7c-0.8,0.7-1.9,1.3-3.2,1.7c-1.3,0.4-2.7,0.6-4.4,0.6H181V84.2z M187.4,96
      c1.3,0,2.3-0.3,3.1-0.8c0.8-0.5,1.1-1.4,1.1-2.6v0c0-1.2-0.4-2.1-1.1-2.6c-0.8-0.5-1.8-0.8-3.1-0.8h-0.9V96H187.4z"/>
    <path style={styles.st1} d="M211.1,84.1h5.5l7,16.7h-6l-0.9-2.2h-5.8l-0.9,2.2H204L211.1,84.1z M215.3,94.7l-1.5-4l-1.5,4H215.3z"/>
    <path style={styles.st1} d="M224.5,84.2h9.3c1.2,0,2.1,0.1,2.9,0.4c0.8,0.3,1.4,0.6,1.9,1.1c0.3,0.3,0.5,0.7,0.7,1.1s0.3,0.9,0.3,1.5v0
      c0,1-0.3,1.8-0.8,2.4c-0.5,0.6-1.3,1.1-2.2,1.4c1.1,0.3,1.9,0.8,2.6,1.4c0.6,0.6,1,1.5,1,2.6v0c0,0.7-0.1,1.3-0.4,1.8
      c-0.3,0.6-0.7,1-1.2,1.5c-0.5,0.4-1.2,0.7-2,1c-0.8,0.2-1.7,0.3-2.8,0.3h-9.2V84.2z M232.3,90.8c1.2,0,1.8-0.4,1.8-1.1v0
      c0-0.8-0.6-1.1-1.8-1.1h-2.4v2.3H232.3z M232.7,96.7c0.6,0,1.1-0.1,1.4-0.3c0.3-0.2,0.5-0.5,0.5-0.9v0c0-0.4-0.2-0.7-0.5-0.9
      c-0.3-0.2-0.8-0.3-1.4-0.3h-2.8v2.5H232.7z"/>
    <path style={styles.st1} d="M247.3,84.1h5.5l7,16.7h-6l-0.9-2.2h-5.8l-0.9,2.2h-5.9L247.3,84.1z M251.6,94.7l-1.5-4l-1.5,4H251.6z"/>
  </g>
  <path style={styles.st1} d="M74.1,58.6v-7.5c0-1.1,0.9-2,2-2h20.6c1.2,0,2.2-0.7,2.7-1.7l4.5-9.8c0.9-2-0.5-4.3-2.7-4.3H76.1
    c-1.1,0-2-0.9-2-2v-6.9c0-1.1,0.9-2,2-2H109c1.2,0,2.2-0.7,2.7-1.7l5.1-11c0.9-2-0.5-4.3-2.7-4.3H57.3c-1.7,0-3,1.3-3,3v29.4
    c0,1.9-2.4,2.7-3.6,1.2l-24.9-32c-0.8-1-1.9-1.5-3.2-1.5H8.9c-1.7,0-3,1.3-3,3v66.2c0,1.7,1.3,3,3,3h13.8c1.7,0,3-1.3,3-3V43.8
    c0-1.9,2.4-2.7,3.6-1.2L55.3,76c0.8,1,1.9,1.5,3.2,1.5h25c1.2,0,2.2-0.7,2.7-1.7l5.1-11c0.9-2-0.5-4.3-2.7-4.3H76.1
    C75,60.6,74.1,59.7,74.1,58.6z"/>
  <path style={styles.st1} d="M128.5,6.5L96.9,74.7c-0.6,1.3,0.4,2.8,1.8,2.8h158.4c1.1,0,2-0.9,2-2V7.3c0-1.1-0.9-2-2-2H130.3
    C129.5,5.3,128.8,5.8,128.5,6.5z"/>
  <path style={styles.st2} d="M141.2,19.5l-19.8,42.7c-0.3,0.6,0.1,1.2,0.8,1.2h1.6c0.3,0,0.6-0.2,0.8-0.5l5.2-11.4
    c0.1-0.3,0.4-0.5,0.8-0.5h24.9c0.3,0,0.6,0.2,0.8,0.5l5.2,11.4c0.1,0.3,0.4,0.5,0.8,0.5h1.7c0.6,0,1-0.6,0.8-1.2l-19.8-42.7
    c-0.1-0.3-0.4-0.5-0.8-0.5H142C141.7,19,141.4,19.2,141.2,19.5z M131.8,46.9l10.4-22.7c0.3-0.7,1.2-0.7,1.5,0L154,46.9
    c0.3,0.6-0.2,1.2-0.8,1.2h-20.6C132,48.1,131.6,47.5,131.8,46.9z"/>
  <path style={styles.st2} d="M202.4,51.3c0-1.5-0.3-2.8-0.8-4c-0.5-1.2-1.3-2.2-2.2-3c-0.9-0.9-1.9-1.6-3.1-2.1c-0.6-0.3-1.2-0.5-1.8-0.8
    c-0.7-0.2-0.7-1.2-0.1-1.5c0.3-0.2,0.6-0.3,0.9-0.5c0.9-0.6,1.7-1.3,2.4-2.1c0.7-0.8,1.3-1.8,1.7-3c0.4-1.1,0.7-2.5,0.7-4v-0.1
    c0-2.7-0.9-5-2.8-6.9c-1.2-1.2-2.8-2.2-4.7-2.9c-1.9-0.7-4.2-1-6.7-1h-17.3c-0.5,0-0.8,0.4-0.8,0.8v42.4c0,0.5,0.4,0.8,0.8,0.8h18.2
    c2.4,0,4.5-0.3,6.5-0.8c1.9-0.6,3.6-1.4,5-2.4c1.4-1,2.4-2.3,3.2-3.8c0.8-1.5,1.1-3.2,1.1-5V51.3z M170.8,23.1
    c0-0.5,0.4-0.8,0.8-0.8h14c3.6,0,6.3,0.8,8.2,2.3c1.9,1.5,2.8,3.5,2.8,5.9v0.1c0,1.5-0.3,2.8-0.8,3.9c-0.6,1.1-1.4,2.1-2.4,2.9
    c-1,0.8-2.2,1.3-3.6,1.7c-1.4,0.4-2.9,0.6-4.5,0.6h-13.7c-0.5,0-0.8-0.4-0.8-0.8V23.1z M199.1,51.4c0,2.8-1.1,5-3.3,6.6
    c-2.2,1.6-5.2,2.4-9,2.4h-15.1c-0.5,0-0.8-0.4-0.8-0.8V43.5c0-0.5,0.4-0.8,0.8-0.8h14.1c4.4,0,7.7,0.7,10,2.2
    c2.3,1.5,3.4,3.6,3.4,6.4V51.4z"/>
  <path style={styles.st2} d="M225.1,19H223c-0.3,0-0.6,0.2-0.8,0.5l-19.8,42.7c-0.3,0.6,0.1,1.2,0.8,1.2h1.6c0.3,0,0.6-0.2,0.8-0.5
    l5.2-11.4c0.1-0.3,0.4-0.5,0.8-0.5h24.9c0.3,0,0.6,0.2,0.8,0.5l5.2,11.4c0.1,0.3,0.4,0.5,0.8,0.5h1.7c0.6,0,1-0.6,0.8-1.2
    l-19.8-42.7C225.7,19.2,225.4,19,225.1,19z M212.9,46.9l10.4-22.7c0.3-0.7,1.2-0.7,1.5,0L235,46.9c0.3,0.6-0.2,1.2-0.8,1.2h-20.6
    C213,48.1,212.6,47.5,212.9,46.9z"/>
  </svg>

    </div>);
  }

}



// WEBPACK FOOTER //
// ./src/components/svglogos/LoginLogo/NEABALogo.js